import React, { FunctionComponent, useEffect } from 'react';
import LoadingComponentOverlay from '@/components/loading/LoadingComponentOverlay';
import bodyScrollLock from '@/utility/bodyScrollLock/bodyScrollLock';
import useLoadingContext from '@jetslash/market-frontend-shared-core/src/contexts/LoadingContextProvider/useLoadingContext';
import Modal from './Modal';

interface IProps {}

/**
 * ModalPage
 *
 * Layout component for rendering Routes as a Modal (like FlightSearchResultModalPage)
 *
 * @constructor
 */

interface IProps {
  title: string;
  onCancel: () => any;
  showFailure?: boolean;
  size?: 'page' | 'medium';
  hideCancel?: boolean;
  visible?: boolean;
  mobileFullScreen?: boolean;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const ModalPage: FunctionComponent<IProps> = ({
  title,
  onCancel,
  children,
  showFailure,
  size,
  hideCancel,
  visible = true,
  mobileFullScreen = false,
  style,
}) => {
  const onCancelWrapper = (e) => {
    bodyScrollLock.disable();
    if (hideCancel) {
      e.stopPropagation();
    } else {
      e.stopPropagation();
      onCancel();
    }
  };
  const { loading } = useLoadingContext();

  const modalSize = size || 'page';
  const successProps = {
    wrapClassName: `${modalSize}-modal-wrapper${hideCancel ? ' hide-cancel-modal-wrapper' : ''}`,
    modalType: modalSize,
    title,
  };

  const failureProps = {
    wrapClassName: null,
    modalType: 'medium',
    title: 'Oops',
  };

  const modalProps = showFailure ? failureProps : successProps;

  useEffect(() => {
    if (visible) {
      bodyScrollLock.enable();
    } else {
      bodyScrollLock.disable();
    }
    // Ensure we always disable body lock when modal is destroyed
    return () => {
      bodyScrollLock.disable();
    };
  }, [visible]);

  return (
    <Modal
      visible={visible}
      wrapClassName={modalProps.wrapClassName}
      // @ts-ignore
      modalType={modalProps.modalType}
      mobileFullScreen={mobileFullScreen}
      destroyOnClose
      title={modalProps.title}
      onCancel={onCancelWrapper}
      hideCancel={hideCancel}
      footer={null}
      maskClosable={false}
      style={style}
    >
      <LoadingComponentOverlay loading={loading} />
      {children}
    </Modal>
  );
};

export default ModalPage;
